// src/redux/attorneyOnboardingSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authenticatedFetch } from "../network/api";

const initialState = {
  selectedProfile: "",
  role: "",
  yoe: "",
  barRegistrations: [],
  firstName: "",
  lastName: "",
  gender: "",
  practiceAreas: [],
  additionalSpecialties: [],
  professionalSuffixes: [],
  adminFirstName: "",
  adminLastName: "",
  adminPhone: "",
  adminEmail: "",
  inPerson: false,
  videoVisit: false,
  specialty: {},
  selectedLoc: {},
  selectedVideoLoc: {},
  lawyerSummary: "",
  education: [],
  workHistory: [],
  professionalMemberships: [],
  aboutYou: "",
  profilePhotoURL: "",
  dob: null,
  caseHighlights: [],
};

export const submitOnboardingInfo = createAsyncThunk(
  "attorneyOnboarding/submitOnboardingInfo",
  // Accept a single payload object and thunkAPI
  async ({ onboardingData, userId, firmId }, { rejectWithValue }) => {
    try {
      const dataToSubmit = { userId, firmId, ...onboardingData };
      const response = await authenticatedFetch("/api/attorney/webapp/onboardAttorney", {
        method: "POST",
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.error || "Submission failed");
      }

      return await response.json();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const attorneyOnboardingSlice = createSlice({
  name: "attorneyOnboarding",
  initialState,
  reducers: {
    updateOnboardingInfo: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    setProfilePhotoUrl: (state, action) => {
      state.profilePhotoURL = action.payload;
    },
    resetOnboardingInfo: () => initialState,
  },
  // Optional: track loading/error states
  extraReducers: (builder) => {
    builder
      .addCase(submitOnboardingInfo.pending, (state) => {
        state.isSubmitting = true;
        state.submitError = null;
      })
      .addCase(submitOnboardingInfo.fulfilled, (state) => {
        state.isSubmitting = false;
      })
      .addCase(submitOnboardingInfo.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitError = action.payload || action.error.message;
      });
  },
});

export const { updateOnboardingInfo, setProfilePhotoUrl, resetOnboardingInfo } =
  attorneyOnboardingSlice.actions;

export default attorneyOnboardingSlice.reducer;
